import { ProductReview, ProductSubnav } from "product";
import { EdgeSection } from "edge-text-media";
import { SubnavDropdown } from "subnav-dropdown";
import { DealerFilter } from "dealer-filter";
import { ContactForm } from "contact";

document.addEventListener("DOMContentLoaded", () => {
  // Bind listener to mobile nav button
  document.getElementById("menu-open").addEventListener("click", () => {
    document.documentElement.classList.toggle("nav-open");
    return false;
  });

  // Init the product page subnav
  ProductSubnav.init();

  // Init the review
  ProductReview.init();

  // Init the subnav dropdown
  SubnavDropdown.init();

  // Init the Dealer Filter
  DealerFilter.init();

  // Init Contact Form
  var contactForm = new ContactForm();
  // Init the edge section
  customElements.define("edge-section", EdgeSection);
});
